import { Box, Typography } from '@mui/material'

import { styles } from './sandbox-banner.styles'
import { IS_PROTOTYPE } from '@hapana/shared/web/services/prototype-mock/config'

const SandboxBanner = () => {
  return (
    <Box sx={styles.container}>
      <Typography sx={styles.text}>
        {IS_PROTOTYPE
          ? 'PROTOTYPE — fake data, no backend. For demos and UI testing only.'
          : 'This is a Hapana Sandbox environment — data here is for testing purposes only'}
      </Typography>
    </Box>
  )
}

export default SandboxBanner
